var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachCopyPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.33331L5.66666 10.6666C4.93028 11.403 4.93028 12.5969 5.66666 13.3333C6.40304 14.0697 7.59695 14.0697 8.33333 13.3333L13.6667 7.99998C15.1394 6.52722 15.1394 4.1394 13.6667 2.66664C12.1939 1.19388 9.80609 1.19388 8.33333 2.66664L2.99999 7.99998C0.790854 10.2091 0.790856 13.7908 3 16C5.20914 18.2091 8.79086 18.2091 11 16L16.3333 10.6666",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachCopyPin);
export default __webpack_public_path__ + "static/media/attach-copy-pin.45a15b0a20e65d2ea6fb38cea8b35a34.svg";
export { ForwardRef as ReactComponent };